import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=263b06cd&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('263b06cd')) {
      api.createRecord('263b06cd', component.options)
    } else {
      api.reload('263b06cd', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=263b06cd&", function () {
      api.rerender('263b06cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-27DyyNsjIIS7g/JS/comp/ImgFallback.vue"
export default component.exports